import { Component } from '@angular/core';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-menu',
  templateUrl: './app-menu.component.html',
  styleUrls: ['./app-menu.component.scss'],
})
export class AppMenuComponent {
  constructor(private userService: UserService) {}

  get isLimitedAccess(): boolean {
    return this.userService.isLimitedAccessRole();
  }
}
